export default __webpack_public_path__ + "static/media/avatar_brown_bear6.11a67013.mp3";